module.exports = __webpack_public_path__ + "static/media/amateur.2699850a.svg";